import { render, staticRenderFns } from "./CBAG1040.vue?vue&type=template&id=f09f2dfe&scoped=true"
import script from "./CBAG1040Controller.ts?vue&type=script&lang=ts&external"
export * from "./CBAG1040Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CBAG1040.vue?vue&type=style&index=0&id=f09f2dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09f2dfe",
  null
  
)

export default component.exports